import React, { useState, useEffect, useMemo } from 'react';
import { Button, ButtonGroup, Col, Row, Accordion, Card } from 'react-bootstrap';
import { Header, Segment, Image, Dimmer, Loader } from 'semantic-ui-react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import { Link, useHistory } from "react-router-dom";
import Amplify, { API, Auth } from 'aws-amplify';
import { Typography as ATypography } from 'antd';

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    lineHeight: '24px',
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    '& .cellValue': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}));

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <div
      ref={wrapper}
      className={classes.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={cellDiv}
        style={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <div ref={cellValue} className="cellValue">
        {value}
      </div>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8, wordWrap: "break-word" }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </div>
  );
});

GridCellExpand.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
  return (
    <GridCellExpand
      value={params.value ? params.value.toString() : ''}
      width={params.colDef.computedWidth}
    />
  );
}

renderCellExpand.propTypes = {
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The cell value, but if the column has valueGetter, use getValue.
   */
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.object,
    PropTypes.string,
    PropTypes.bool,
  ]),
};

export default function PCPD_Queue() {

  const [items, setItems] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 2,
      renderCell: renderCellExpand,
    },
    {
      field: 'Name',
      headerName: 'Name',
      flex: 1.5,
      // hide: true,
      renderCell: renderCellExpand,
    },
    {
      field: 'Hem',
      headerName: 'Hem',
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'Status',
      headerName: 'Status',
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: 'Email',
      headerName: 'Email',
      flex: 1.5,
      renderCell: renderCellExpand,
    },
    {
      field: 'Timestamp',
      headerName: 'Date',
      flex: 1.5,
      renderCell: (params) => (
        <>{new Date(Number(params.value)).toLocaleString()}</>
      ),
    },
  ];


  async function getQueue() {
    // Amplify.Logger.LOG_LEVEL = "DEBUG";
    const session = await Auth.currentCredentials();
    // console.log(session)
    const apiRequest = {
      headers: {
        "Content-Type": "application/json",
        // "Authorization":  session.getIdToken().getJwtToken()
      },
    };

    return await API
      .get("P450", "/queue", apiRequest)
      .then(
        (data) => {
          setItems(processItems(data.Items));
          setIsLoaded(true);
          // console.log(data);
        },
        (error) => {
          console.log(error);
          setIsLoaded(true);
        }
      );
  };

  function processItems(params) {
    let currentItems = [];
    for (let i = 0; i < params.length; i++) {
      let currentItem = params[i];
      currentItem["id"] = params[i].PK;
      currentItems.push(currentItem);
    }
    return currentItems;
  }

  useEffect(() => {
    getQueue();
  }, [])

  return (
    <div style={{
      background: "#FFFFFF"

    }}>

      <Row>
        <Col>
        </Col>
        <Col md={10}>

          <div style={{

            height: "50px"
          }}>
          </div>
          <div>
            <Card>
              <Card.Header>
                <Header textAlign='center'>
                  <span style={{ color: "#6495ED" }} >Queue</span>
                </Header>
              </Card.Header>
              <Card.Body>

                <div style={{ margin: "25px 200px 25px 200px" }}>
                  <ATypography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Perform structural modeling of the user-submitted sequence using Boltz.</blockquote></ATypography.Paragraph>
                </div>

                {
                  isLoaded
                    ?
                    <DataGrid
                      rows={items}
                      columns={columns}
                      autoHeight
                      pageSize={10}
                      // rowsPerPageOptions={[10, 25, 50, 100]}
                      // pagination
                      components={{
                        Toolbar: GridToolbar,
                      }}
                      sortModel={[
                        {
                          field: 'Timestamp',
                          sort: 'desc',
                        },
                      ]}
                    />
                    :
                    <Segment>
                      <Dimmer active inverted>
                        <Loader size='medium'>Loading</Loader>
                      </Dimmer>

                      <Image src='../paragraph.png' />
                    </Segment>
                }

              </Card.Body>
            </Card>

          </div>


          <div>


            <div>

            </div>



          </div>
          <div style={{

            height: "50px"
          }}>
          </div>
        </Col>
        <Col>
        </Col>
      </Row>
    </div>

  );
}